// removed by extract-text-webpack-plugin
module.exports = {"hrule":"HorizontalRule__hrule"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/HorizontalRule/HorizontalRule.scss
// module id = 1773
// module chunks = 8